var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SMTP',{attrs:{"settings":_vm.settings}}),(_vm.isRPTradeModule)?_c('RPTrage',{attrs:{"settings":_vm.settings}}):_vm._e(),(_vm.isReportModule || _vm.isONEProject)?_c('Reports',{attrs:{"settings":_vm.settings}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }